import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	cancelButton: {
		id: 'admin-pages-priorities.priority-modals.delete-modal.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Content for "Cancel" button in priority delete modal',
	},
	confirmButton: {
		id: 'admin-pages-priorities.priority-modals.delete-modal.confirm-button',
		defaultMessage: 'Delete',
		description: 'Primary call to action button in the modal to delete a priority',
	},
	deleteModalBody: {
		id: 'admin-pages-priorities.priority-modals.delete-modal.delete-modal-body',
		defaultMessage: 'Are you sure you want to delete "{priorityName}"?',
		description: 'Confirmation message for deleting a priority with no associated schemes',
	},
	deleteModalTitle: {
		id: 'admin-pages-priorities.priority-modals.delete-modal.delete-modal-title',
		defaultMessage: 'Are you sure?',
		description: 'Title for modal to delete a priority with no associated schemes',
	},
});
